import { EventsCardListCombinedProps } from './types';

const usePresenter = (props: EventsCardListCombinedProps): EventsCardListCombinedProps => {
  return props;
};

export default usePresenter;
